import validator from 'validator';

const DEFAULT_MESSAGE = 'Veuillez saisir une adresse email valide';

export const mustBeEmail =
  (message?: string, allowEmpty: boolean = true) =>
  (value: string) => {
    if (allowEmpty && !value) return undefined;
    const isValid = validator.isEmail(value);
    return isValid ? undefined : message || DEFAULT_MESSAGE;
  };
